import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-header-socialmedia-icons',
    templateUrl: './header-socialmedia-icons.component.html',
    styleUrl: './header-socialmedia-icons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderSocialmediaIconsComponent implements OnInit{
  public componentData: CmsLinkComponent;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
